module.exports = __webpack_public_path__ + "img/w3_outlet_white.a50c369c.png";